import { useFormContext, Controller } from 'react-hook-form';
import type { InputHTMLAttributes } from 'react';
import type { FieldError } from 'react-hook-form';
import SnilsInput from './SnilsInput';

export type FormSnilsInputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: FieldError;
  name: string;
  unmasked?: boolean;
  label?: string;
};

function FormSnilsInput({
  error,
  name,
  ...restFieldProps
}: FormSnilsInputProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, onChange, value } }) => (
        <SnilsInput
          status={error && 'error'}
          extraText={error?.message}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...restFieldProps}
        />
      )}
    />
  );
}

export default FormSnilsInput;
